<template>
	<div class="row">
		<div class="col-md-6 pt-3 pb-3">
            <h5 class="text-center mb-5">Rozdelenie projektov podľa sektorov</h5>
			<polaris-composition :inline="false" :size="203" :selectable="true" state="polarisComposition"/>
		</div>
        <div class="col-md-6 pt-3 pb-3">
            <h5 class="text-center mb-5">Hodnota projektov</h5>
            <polaris-composition :inline="false" :size="203" :selectable="true" state="polarisValues"/>
        </div>
	</div>
</template>

<script>
import PolarisComposition from "../../../components/PolarisComposition";

export default {
	name: "PolarisCompositionFull",
	components: { PolarisComposition },
};
</script>

<style scoped></style>
